import React, { useEffect, useState } from "react";
import { debounce } from "underscore";

const getScrollTop = () => {
  const [top, setTop] = useState(0);
  useEffect(() => {
    window.addEventListener("scroll", debounce(getTop, 10));
    return () => {
      window.addEventListener("scroll", debounce(getTop, 10));
    };
  }, []);
  const getTop = () => {
    setTop(window.scrollY);
  };
  return top;
};

export default getScrollTop;
